import dataSender from './ApiService';

export function deleteCandidateFile(id,customerName) {
    return dataSender('/api/v2/candidates/files/'+id, {apiKey: sessionStorage.getItem('apiKey-' + customerName), candidateId: sessionStorage.getItem('userId-'+customerName)}, 'DELETE');
}
